import { utilities } from 'utils/utilities';
import { Enrollment, EnrollmentDto } from './Enrollment';

export type BillingType = 'Hourly' | 'Fixed';

export interface ProjectEstimationEnrollmentDto extends EnrollmentDto {
  defaultBillingType: BillingType;
}

export class ProjectEstimationEnrollment extends Enrollment {
  readonly type: 'Models.Enrollments.ProjectEstimationEnrollment' = 'Models.Enrollments.ProjectEstimationEnrollment';

  defaultBillingType: BillingType;

  constructor(
    id?: string,
    defaultBillingType: BillingType = 'Fixed'
  ) {
    super(id);
    this.defaultBillingType = defaultBillingType;
  }

  toDto(): ProjectEstimationEnrollmentDto {
    return {
      id: this.id,
      enrollmentType: this.type,
      dtoType: 'Models.Api.Dtos.ProjectEstimationEnrollmentDto',
      defaultBillingType: this.defaultBillingType,
    };
  }

  static fromDto(
    dto?: Partial<ProjectEstimationEnrollmentDto> | ProjectEstimationEnrollment | any
  ): ProjectEstimationEnrollment {
    if (!dto) {
      return new ProjectEstimationEnrollment(utilities.DEFAULT_GUID);
    }

    if (dto instanceof ProjectEstimationEnrollment) {
      return dto;
    }

    const id = dto.id ?? utilities.DEFAULT_GUID;
    const defaultBillingType = (dto.defaultBillingType === 'Hourly' || dto.defaultBillingType === 'Fixed')
      ? dto.defaultBillingType
      : 'Fixed';

    return new ProjectEstimationEnrollment(id, defaultBillingType);
  }
}

Enrollment.register(
  'Models.Enrollments.ProjectEstimationEnrollment',
  (d?: any) => ProjectEstimationEnrollment.fromDto(d)
);
